export class SaveFileLocal {
  static downloadFile = (data: string, fileName: string, type: string) => {
    const blob = new Blob([data], { type })
    const url = URL.createObjectURL(blob)

    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()

    URL.revokeObjectURL(url)
  }

  /**
   * ローカルにxmlをDLする
   * @param xml
   * @param fileName
   */
  static saveXML = (xml: string, fileName = 'debug.xml') => {
    xml = SaveFileLocal.formatXML(xml)
    SaveFileLocal.downloadFile(xml, fileName, 'application/xml')
  }

  /**
   * ローカルにjsonをDLする
   * @param data
   * @param fileName
   */
  static saveJSON = (data: unknown, fileName = 'debug.json') => {
    SaveFileLocal.downloadFile(
      JSON.stringify(data, null, 2),
      fileName,
      'application/json'
    )
  }

  /**
   * JSON文字列をそのままDLする（パース前の生データ確認用）
   */
  static saveRawJson = (raw: string, fileName = 'debug.json') => {
    SaveFileLocal.downloadFile(raw, fileName, 'application/json')
  }

  /**
   * JSON.parseが投げたSyntaxErrorの発生箇所をテキストで返す
   * 例: "Line 45, Col 12\n  >>> 45: ...context...\n         ^"
   */
  static describeJsonSyntaxError = (json: string, error: SyntaxError): string => {
    const msg = error.message;
    let line = -1;
    let col = -1;

    // Chrome/Node: "... at position N"
    const posMatch = msg.match(/at position (\d+)/);
    // Firefox: "... at line N column N of the JSON data"
    const lineColMatch = msg.match(/at line (\d+) column (\d+)/);

    if (posMatch) {
      const pos = parseInt(posMatch[1], 10);
      const before = json.slice(0, pos);
      const lines = before.split('\n');
      line = lines.length;
      col = lines[lines.length - 1].length + 1;
    } else if (lineColMatch) {
      line = parseInt(lineColMatch[1], 10);
      col = parseInt(lineColMatch[2], 10);
    }

    if (line === -1) {
      return `SyntaxError: ${msg}`;
    }

    const jsonLines = json.split('\n');
    const contextStart = Math.max(0, line - 3);
    const contextEnd = Math.min(jsonLines.length, line + 2);
    const lineNumWidth = String(contextEnd).length;
    const contextLines = jsonLines
      .slice(contextStart, contextEnd)
      .map((l, i) => {
        const lineNum = contextStart + i + 1;
        const prefix = lineNum === line ? '>>> ' : '    ';
        return `${prefix}${String(lineNum).padStart(lineNumWidth)}: ${l}`;
      });

    const pointer = `${''.padStart(4 + lineNumWidth + 2 + col - 1)}^`;
    const context = [...contextLines, pointer].join('\n');

    return `SyntaxError at Line ${line}, Col ${col}\n${msg}\n\nContext:\n${context}`;
  }

  /**
   * apiレスポンスのxml文字列に適切な改行やインデントを設定する
   * @param xml
   */
  static formatXML = (xml: string) => {
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(xml, "application/xml")

    const xslt = `
      <xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">
      <xsl:output method="xml" indent="yes"/>
      <xsl:strip-space elements="*"/>
      <xsl:template match="@*|node()">
      <xsl:copy>
      <xsl:apply-templates select="@*|node()"/>
      </xsl:copy>
      </xsl:template>
      </xsl:stylesheet>
    `

    const xsltDoc = parser.parseFromString(xslt, "application/xml")
    const processor = new XSLTProcessor()
    processor.importStylesheet(xsltDoc)

    const resultDoc = processor.transformToDocument(xmlDoc)
    const serializer = new XMLSerializer()

    return serializer.serializeToString(resultDoc)
  }

}